<script lang="ts">
  import type { TimeSlot } from "../../../../../../../../_logic/calendar-types"

  const { timeSlots = [] }: { timeSlots: TimeSlot[] } = $props()
</script>

<div class="time-scale">
  {#each timeSlots.slice(0, -1) as slot (slot.value)}
    <div class="time-slot" class:unlabeled={!slot.showLabel}>
      {#if slot.showLabel}
        <span>{slot.label}</span>
      {/if}
    </div>
  {/each}
</div>

<style lang="less">
  .time-scale {
    display: grid;
    grid-auto-rows: var(--slot-height);
    row-gap: 0;

    .time-slot {
      height: var(--slot-height);
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      color: var(--cal-time-text, var(--cal-text-muted, #6d97b0));
      font-size: 0.8rem;
      opacity: 1;

      span {
        display: inline-block;
        padding-right: 2px;
        color: inherit;
        opacity: 1;
        transform: translateX(-2px);
      }

      &.unlabeled {
        opacity: 0.42;
      }
    }
  }
</style>
